@if(service.viewDroplistItems.length){
<div class="volunteering-engagements-views-part">

	@if(service.selectedViewItem(); as selectedViewItem){

	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='uniqueId' style='display:inline-block'>
	</droplist>

	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.ContactRequests) {
	<volunteering-contact-requests-view-part></volunteering-contact-requests-view-part>
	}
	@case (service.viewId.OpenEngagements) {
	<volunteering-open-engagements-view-part></volunteering-open-engagements-view-part>
	}
	@case (service.viewId.CompletedEngagements) {
	<volunteering-completed-engagements-view-part></volunteering-completed-engagements-view-part>
	}
	@case (service.viewId.ScheduledFollowUps) {
	<volunteering-scheduled-follow-ups-view-part></volunteering-scheduled-follow-ups-view-part>
	}
	}
	}

</div>
}